import analytics, { SEGMENT_EVENTS } from '@/utils/analytics';
import { enUS } from 'date-fns/locale';

export const USER_SETTINGS = {
  LANG: 'en-us',
  FALLBACK_LANG: 'en-us',
};

export const SUPPORTED_LANGUAGE_LIST = [
  {
    name: () => 'English',
    value: 'en-us',
  },
];

export const SUPPORTED_LANGUAGES = {
  ENGLISH: 'en-us',
};

export const updateLanguage = async (store, payload) => {
  // Remove this condition once LanguageSwicher component is ready for production
  const language = payload.nextLanguage;
  if (
    language !== store.getters.selectedLanguage &&
    Object.values(SUPPORTED_LANGUAGES).includes(language)
  ) {
    if (store.getters.userIsLoggedIn) {
      await store.dispatchApiAction('UPDATE_USER_LANGUAGE', { language });
    } else {
      store.dispatch('setLanguage', language);
    }
    analytics.track(SEGMENT_EVENTS.fe_toggle_language, {
      target: payload.target,
      previousLanguage: payload.previousLanguage,
      nextLanguage: payload.nextLanguage,
    });
  }
};

export const gettingLocaleForDatepickerLib = (locale) => {
  return enUS;
};
